import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdOutlineWork } from "react-icons/md";
import { MdSchool } from "react-icons/md";

import React from "react";

function VerticalTimeLine() {
  return (
    <div
      className=""
      style={{ background: "#e3e3e3", marginTop: "3em", borderRadius: "15px" }}
    >
      <div
        style={{
          width: "100%",
          display: "inline-block",
          alignContent: "center",
          justifyContent: "center",
          padding: "3em 0px",
        }}
      >
        <h3
          className="ertical-timeline-element-title"
          style={{ textAlign: "center" }}
        >
          Work experience & Education
        </h3>
        <div className="" style={{ textAlign: "center" }}>
          My previous jobs and my qualifications.
        </div>
      </div>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          //   contentStyle={{ background: "rgb(33, 150, 243)", color: "black" }}
          //   contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
          date="August 2024 - present"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">
            Full-stack Developer (Intern)
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Pocatello, ID</h4>
          <p>
            Full-Stack Development, UI/UX Optimization, Data Visualiztion,
            Algorithm Optimization, Creative problem-Solving
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="January 2024 - May 2025"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">
            Masters in Computer Science
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Idaho State University
          </h4>
          <p>Pocatello, ID</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="May 2024 - February 2025"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">
            AI/ML Research Assistant
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Pocatello, ID</h4>
          <p>
            Machine Learning, Model Fine-Tuning, Data Preprocessing, Performance
            Benchmarking, Report Writing
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="August 2017 - May 2021"
          iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">
            Bachelor of Science in Computer Science and Information Technology
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Tribhuvan University
          </h4>
          <p>Kathmandu, Nepal</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="August 2022 - December 2023"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">
            Junior Software Developer
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Kathmandu, Nepal
          </h4>
          <p>
            Full-Stack Web Development, React.js/ Redux, Agile Development, Data
            Visualization, Mentorship & Training
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="April 2022 - July 2022"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">
            Frontend Web Developer Intern
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Kathmandu, Nepal
          </h4>
          <p>JavaScript/ TypeScript, State Management, Responsive Web Design</p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}

export default VerticalTimeLine;
